import gql from 'graphql-tag'

export const getBlogs = gql`
  query GetBlogs($blogId: ID, $systemType: String!, $limit: Int,$patientId:String) {
    blogs(blogId: $blogId, systemType: $systemType,patientId:$patientId) {
      _id
      title
      type
      avatar
      content
      authorInfo {
        _id
        nickname
        petname
        avatar
        userId
      }
      publishedAt
      videoSources
      audioSources
      articleSource
      whoSendGiftCount
      giftCount
      commentCount(limit: $limit)
      comments(systemType: $systemType, limit: $limit,patientId:$patientId) {
        _id
        content
        showState
        commentImage
        user {
          _id
          nickname
          petname
          avatar
        }
        secondReplys {
          _id
          content
          patientId
          userName
          userAvatar
          createdAt
          beReplyedUserId
          beReplyedName
          showState
          commentImage
        }
        votes
        createdAt
        serviceIcon {
          cityHasGoods
          list
          vipEntryBlocked
        }
      }
      votes(systemType: $systemType)
      views(systemType: $systemType)
    }
  }
`

export const getCorrelationBlogs = gql`
  query getCorrelation($blogId: String) {
    getCorrelationArticleArray(blogId: $blogId) {
      _id
      title
      avatar
      author
      publishedAt
      views
      comments
      sharings
    }
  }
`
export const getBlogRecommend = gql`
  query getBlogRecommend($blogId: String, $patientId: String) {
    getBlogRecommend(blogId: $blogId, patientId: $patientId) {
      _id
      title
      avatar
      author
      publishedAt
      views
      comments
      sharings
      location
      type
      recordId
      appVersion
      skuId
    }
  }
`
export const getArticleHelpState = gql`
  query getArticleHelpState($articleId: String!, $patientId: String!) {
    articleHelpState(articleId: $articleId, patientId: $patientId) {
      articleId
      patientId
      helpState
    }
  }
`

export const getBlogGiftInfo = gql`
  query GetBlogs($blogId: ID, $systemType: String!) {
    blogs(blogId: $blogId, systemType: $systemType) {
      _id
      whoSendGiftCount
      giftCount
    }
  }
`

export const isShowSendGift = gql`
  query isShowSendGift($patientId: String!) {
    isShowSendGift(patientId: $patientId) {
      showSendGift
    }
  }
`

export const queryFollowState = gql`
  query followState($selfId: String, $blogId: String) {
    getFollowState(selfId: $selfId, blogId: $blogId)
  }
`



// WEBPACK FOOTER //
// ./src/modules/knowledge/actions/queries.js